<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize" >
            <el-form-item>
                <el-button type="success" @click="handleAdd">新增</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="taskRewardList" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
          <!--  <el-table-column type="selection" width="55"></el-table-column>-->
            <el-table-column type="index" label="序号" width="60"></el-table-column>
            <el-table-column prop="taskName" label="任务名称"></el-table-column>
            <el-table-column label="任务奖励类型">
                <template  slot-scope="scope">
                    <div v-if="scope.row.rewardType==1">优惠券</div>
                    <div v-else-if="scope.row.rewardType==2">余额</div>
                </template>
            </el-table-column>
            <el-table-column prop="rewardName" label="余额推送文案"></el-table-column>
            <el-table-column prop="rewardDataName" label="任务奖励数据"></el-table-column>
            <el-table-column label="状态">
                <template  slot-scope="scope">
                    <div v-if="scope.row.status==0">禁用</div>
                    <div v-else-if="scope.row.status==1">启用</div>
                </template>
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click="handleEdit(scope.row)">修改</el-button>
                    <el-button type="warning " size="mini" @click="handleDel(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="formInline.recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="添加任务奖励" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="120px">
                <el-form-item label="任务" >
                    <el-select v-model="form.taskId" clearable  placeholder="任务名称">
                        <el-option
                                v-for="item in taskList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务奖励类型" >
                    <el-select v-model="form.rewardType" clearable  placeholder="任务奖励类型">
                        <el-option label="优惠券" value="1"></el-option>
                        <el-option label="余额" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="任务奖励数据">
                    <el-input v-if="form.rewardType==2" v-model="form.rewardData" placeholder="任务奖励数据"></el-input>
                    <el-select v-if="form.rewardType==1" v-model="form.rewardData" clearable  placeholder="奖励数据">
                        <el-option
                                v-for="item in qrcodes"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="余额推送文案">
                    <el-input v-model="form.rewardName" placeholder="余额推送文案"></el-input>
                </el-form-item>
                <el-form-item label="状态" >
                    <el-select v-model="form.status" clearable  placeholder="状态">
                        <el-option label="启用" value="1"></el-option>
                        <el-option label="禁用" value="0"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addTaskReward(form)">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {taskRewardList,saveTaskReward,delTaskReward,getOptionTaskList,getVipQrcodesDropList} from '../../api/api'
    //定义组件
    export default{
        data(){
            return {
                qrcodes:[],
                taskList:[],
                taskRewardList:[],
                loading:true,
                selectValue: '',
                dialogFormVisible:false,
                form:{
                    "id" : "",
                    "taskId":"",
                    "taskName":"",
                    "taskType":"",
                    "rewardType":"",
                    "rewardName":"",
                    "rewardData":"",
                    "status":""
                },
                formInline:{
                    currentPage:1,
                    recordsTotal:0,
                    pageSize:10,
                }
            }
        },
        //挂载时候执行
        mounted(){
            //获取会员等级下拉
            getOptionTaskList({}).then((res) => {
                this.taskList = res.data.value;
            })
            //获取会员活动二维码下拉数据
            getVipQrcodesDropList({}).then((res) => {
                this.qrcodes = res.data.value;
            })
            //初始化首页数据
            this.getList();
        },
        methods:{
            //定义查询方法
            getList(){
                this.loading = true;
                taskRewardList(this.formInline).then((res) => {
                    this.loading = false;
                    this.taskRewardList = res.data.list;
                    this.formInline.recordsTotal = res.data.total;
                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList();
            },
            handleEdit(row){
                this.form.id = row.id;
                this.form.taskId = row.taskId;
                this.form.taskName = row.taskName;
                this.form.taskType = row.taskType;
                this.form.rewardType = row.rewardType;
                this.form.rewardName = row.rewardName;
                this.form.rewardData = row.rewardData;
                this.form.status = row.status;
                this.dialogFormVisible = true;
            },
            handleDel(row){
                this.$confirm('删除任务奖励, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delTaskReward({id:row.id}).then((res) => {
                        if(res.data.status==200){
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage,this.pageSize);
                        }else{
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                    })
                }).catch(() => {

                });
            },
            handleAdd(){
                this.form={}
                this.dialogFormVisible = true;
            },
            addTaskReward(form){
                saveTaskReward(form).then((res) => {
                    if(res.data.status==200){
                        this.$message({
                            showClose: true,
                            message: '成功',
                            type: 'success'
                        });
                        this.dialogFormVisible = false;
                        this.getList(this.currentPage,this.pageSize);
                    }else{
                        this.$message({
                            showClose: true,
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/vip/vipTaskReward.vue